import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {Typography} from "@material-ui/core";

const values = ["buy to open", "sell to open"];

export default function OptionBtoStoDropDown({optionDirection, setOptionDirection}) {
    return (<>
        <TextField
            select
            value={optionDirection}
            variant="outlined"
            size="small"
            style={{backgroundColor: "white", width: "100%"}}
            onChange={ev => setOptionDirection(ev.target.value)}
            label={<Typography style={{fontSize: 10}}>Option Direction</Typography>}
        >
            {values.map((option) => (
                <MenuItem key={option} value={option}>
                    <Typography style={{fontSize: 9}}>{option}</Typography>
                </MenuItem>
            ))}
        </TextField>
    </>);
}